import PropTypes from 'prop-types'
import React, { createContext, useContext } from 'react'
import RequestStatus from '../../../components/RequestStatus/RequestStatus'
import useRequestStatus from '../useRequestStatus.js/useRequestStatus'

const RequestStatusContext = createContext()

export function useRequestStatusContext() {
  const context = useContext(RequestStatusContext)
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider')
  }

  return context
}

export function RequestStatusProvider({ children }) {
  const contextValue = useRequestStatus()
  return (
    <RequestStatusContext.Provider value={contextValue}>
      <RequestStatus
        isOpen={contextValue.isOpen}
        onClose={contextValue.handleClose}
        bodyProps={{ body: contextValue.body }}
        headerProps={{
          title: contextValue.title,
          code: contextValue.code,
          customColor: contextValue.customColor,
        }}
      />
      {children}
    </RequestStatusContext.Provider>
  )
}

RequestStatusProvider.propTypes = {
  children: PropTypes.node,
}
